import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(fetchUserSagaWorker),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(fetchUserSagaWatcher),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(fetchUserSagaWorkerE2E),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(fetchUserSagaWatcherE2E),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(fetchUserRoleSagaWorker),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(fetchUserRoleSagaWatcher),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(loginUserSagaWorker),
    _marked8 = /*#__PURE__*/_regeneratorRuntime.mark(loginUserSagaWatcher),
    _marked9 = /*#__PURE__*/_regeneratorRuntime.mark(logoutUserSagaWorker),
    _marked10 = /*#__PURE__*/_regeneratorRuntime.mark(logoutUserSagaWatcher),
    _marked11 = /*#__PURE__*/_regeneratorRuntime.mark(authSaga);

import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { actions } from '@store/auth/auth.actions';
import { AuthService } from '@services';
import { ConstantsUtil } from '@utils';
import { FETCH_E2E_USER_REQUEST, FETCH_USER_REQUEST, FETCH_USER_ROLE_REQUEST, LOGIN_USER_REQUEST, LOGOUT_USER_REQUEST } from './auth.action-types';

/**
 * Fetch user saga worker.
 *
 * @author Mikhail Siutsou
 * @function fetchUserSagaWorker
 * @category Sagas
 * @subcategory Auth
 * @return {Generator<PutEffect | CallEffect, void, ApiError & AxiosResponse<User>>} data.
 */
function fetchUserSagaWorker(action) {
  var _yield$call, data;

  return _regeneratorRuntime.wrap(function fetchUserSagaWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return call(AuthService.apiCurrentUserGet, action.payload.id);

        case 3:
          _yield$call = _context.sent;
          data = _yield$call.data;
          _context.next = 7;
          return put(actions.fetchUserSuccess({
            user: data
          }));

        case 7:
          _context.next = 9;
          return put({
            type: "".concat(FETCH_USER_REQUEST, "/").concat(ConstantsUtil.actions.ASYNC_SUCCESS),
            payload: data
          });

        case 9:
          _context.next = 17;
          break;

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](0);
          _context.next = 15;
          return put(actions.fetchUserFailure({
            error: _context.t0
          }));

        case 15:
          _context.next = 17;
          return put({
            type: "".concat(FETCH_USER_REQUEST, "/").concat(ConstantsUtil.actions.ASYNC_FAILED),
            payload: _context.t0
          });

        case 17:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 11]]);
}
/**
 * Fetch user saga.
 *
 * @author Mikhail Siutsou
 * @function fetchUserSagaWatcher
 * @category Sagas
 * @subcategory Auth
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


function fetchUserSagaWatcher() {
  return _regeneratorRuntime.wrap(function fetchUserSagaWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return all([takeLatest(FETCH_USER_REQUEST, fetchUserSagaWorker)]);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
/**
 * Fetch user saga worker.
 *
 * @author Mikhail Siutsou
 * @function fetchUserSagaWorker
 * @category Sagas
 * @subcategory Auth
 * @return {Generator<PutEffect | CallEffect, void, ApiError & AxiosResponse<User>>} data.
 */


function fetchUserSagaWorkerE2E() {
  var _yield$call2, data;

  return _regeneratorRuntime.wrap(function fetchUserSagaWorkerE2E$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return call(AuthService.apiCurrentUserE2EGet);

        case 3:
          _yield$call2 = _context3.sent;
          data = _yield$call2.data;
          _context3.next = 7;
          return put(actions.fetchUserSuccess({
            user: {
              id: data.id,
              email: data.email,
              status: data.status,
              last_name: data.lastName,
              first_name: data.firstName,
              phone_number: data.phoneNumber,
              user_type: data.userType
            }
          }));

        case 7:
          _context3.next = 9;
          return put({
            type: "".concat(FETCH_E2E_USER_REQUEST, "/").concat(ConstantsUtil.actions.ASYNC_SUCCESS),
            payload: data
          });

        case 9:
          _context3.next = 17;
          break;

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](0);
          _context3.next = 15;
          return put(actions.fetchUserFailure({
            error: _context3.t0
          }));

        case 15:
          _context3.next = 17;
          return put({
            type: "".concat(FETCH_E2E_USER_REQUEST, "/").concat(ConstantsUtil.actions.ASYNC_FAILED),
            payload: _context3.t0
          });

        case 17:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[0, 11]]);
}
/**
 * Fetch user saga.
 *
 * @author Mikhail Siutsou
 * @function fetchUserSagaWatcher
 * @category Sagas
 * @subcategory Auth
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


function fetchUserSagaWatcherE2E() {
  return _regeneratorRuntime.wrap(function fetchUserSagaWatcherE2E$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return all([takeLatest(FETCH_E2E_USER_REQUEST, fetchUserSagaWorkerE2E)]);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}
/**
 * Fetch user roles saga worker.
 *
 * @author Ihar Kazlouski
 * @function fetchUserRoleSagaWorker
 * @category Sagas
 * @subcategory Auth
 * @return {Generator<PutEffect | CallEffect, void, ApiError & AxiosResponse<User>>} data.
 */


function fetchUserRoleSagaWorker(action) {
  var _yield$call3, data;

  return _regeneratorRuntime.wrap(function fetchUserRoleSagaWorker$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return call(AuthService.apiCurrentUserRoleGet, action.payload.id);

        case 3:
          _yield$call3 = _context5.sent;
          data = _yield$call3.data;
          _context5.next = 7;
          return put(actions.fetchUserRoleSuccess({
            roles: data
          }));

        case 7:
          _context5.next = 9;
          return put({
            type: "".concat(FETCH_USER_ROLE_REQUEST, "/").concat(ConstantsUtil.actions.ASYNC_SUCCESS),
            payload: data
          });

        case 9:
          _context5.next = 17;
          break;

        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5["catch"](0);
          _context5.next = 15;
          return put(actions.fetchUserRoleFailure({
            error: _context5.t0
          }));

        case 15:
          _context5.next = 17;
          return put({
            type: "".concat(FETCH_USER_ROLE_REQUEST, "/").concat(ConstantsUtil.actions.ASYNC_FAILED),
            payload: _context5.t0
          });

        case 17:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[0, 11]]);
}
/**
 * Fetch user saga.
 *
 * @author Ihar Kazlouski
 * @function fetchUserSagaWatcher
 * @category Sagas
 * @subcategory Auth
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


function fetchUserRoleSagaWatcher() {
  return _regeneratorRuntime.wrap(function fetchUserRoleSagaWatcher$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return all([takeLatest(FETCH_USER_ROLE_REQUEST, fetchUserRoleSagaWorker)]);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}
/**
 * Login user saga worker.
 *
 * @author Mikhail Siutsou
 * @function loginUserSagaWorker
 * @category Sagas
 * @subcategory Auth
 * @return {Generator<PutEffect | CallEffect, void, ApiError & AxiosResponse<User>>} data.
 */


function loginUserSagaWorker(action) {
  return _regeneratorRuntime.wrap(function loginUserSagaWorker$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}
/**
 * Login user saga.
 *
 * @author Mikhail Siutsou
 * @function loginUserSagaWatcher
 * @category Sagas
 * @subcategory Auth
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


function loginUserSagaWatcher() {
  return _regeneratorRuntime.wrap(function loginUserSagaWatcher$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return all([takeLatest(LOGIN_USER_REQUEST, loginUserSagaWorker)]);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}
/**
 * Logout user saga worker.
 *
 * @author Mikhail Siutsou
 * @function logoutUserSagaWorker
 * @category Sagas
 * @subcategory Auth
 * @return {Generator<PutEffect | CallEffect, void, ApiError & AxiosResponse<void>>} data.
 */


function logoutUserSagaWorker() {
  return _regeneratorRuntime.wrap(function logoutUserSagaWorker$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}
/**
 * Logout user saga.
 *
 * @author Mikhail Siutsou
 * @function logoutUserSagaWatcher
 * @category Sagas
 * @subcategory Auth
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


function logoutUserSagaWatcher() {
  return _regeneratorRuntime.wrap(function logoutUserSagaWatcher$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return all([takeLatest(LOGOUT_USER_REQUEST, logoutUserSagaWorker)]);

        case 2:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10);
}
/**
 * Auth saga.
 *
 * @author Mikhail Siutsou
 * @function authSaga
 * @category Sagas
 * @subcategory Auth
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


export default function authSaga() {
  return _regeneratorRuntime.wrap(function authSaga$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return all([fork(fetchUserSagaWatcher), fork(loginUserSagaWatcher), fork(logoutUserSagaWatcher), fork(fetchUserRoleSagaWatcher), fork(fetchUserSagaWatcherE2E)]);

        case 2:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked11);
}